/* atd-product-add-to-cart.js
   - Emits 'atd:qty-change' from [data-atd-atc] when qty changes
   - Multiplies unit price × qty and updates the price markup
*/
(function () {
  'use strict';

  function onReady(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  onReady(function () {
    document.querySelectorAll('[data-atd-atc]').forEach(initATD);
  });

  function initATD(root) {
    const qtyInput = root.querySelector('.quantity__input');
    if (!qtyInput) return;

    const minusBtn = root.querySelector('button[name="minus"]');
    const plusBtn = root.querySelector('button[name="plus"]');
    const priceBox = root.querySelector('[data-atd-price]');
    if (!priceBox) return;

    const rawFmt = priceBox.dataset.moneyFormat;                 // e.g. ${ {amount} } AUD
    const moneyFormat = (rawFmt && rawFmt.trim().replace(/^"|"$/g, '')) || '${{amount}}';
    // const moneyFormat = priceBox.dataset.moneyFormat || '${{amount}}';
    const unitPriceCents = toNumber(priceBox.dataset.unitPriceCents);
    const compareAtCents = toNumber(priceBox.dataset.compareAtCents);

    // Dispatch our custom event
    const dispatch = () => {
      const qty = clampQty(toNumber(qtyInput.value), qtyInput);
      root.dispatchEvent(new CustomEvent('atd:qty-change', {
        bubbles: true,
        detail: { qty: qty }
      }));
    };

    // Listen to +/- and manual typing
    ['input', 'change'].forEach(evt => qtyInput.addEventListener(evt, dispatch));
    [minusBtn, plusBtn].forEach(btn => btn && btn.addEventListener('click', () => {
      // Wait for <quantity-input> internal update
      setTimeout(dispatch, 0);
    }));

    // React to our custom event
    root.addEventListener('atd:qty-change', function (e) {
      const qty = Math.max(1, toNumber(e.detail && e.detail.qty));
      updatePrice(qty);
    });

    function updatePrice(qty) {
      // totals
      const total = unitPriceCents * qty;
      const compareTotal = compareAtCents ? compareAtCents * qty : 0;

      // Build Dawn-like price markup so styles remain
      const priceHtml = renderPriceHTML(total, compareTotal, moneyFormat);

      const priceRegion = priceBox.querySelector('.price') || priceBox;
      priceRegion.innerHTML = priceHtml;
    }

    function renderPriceHTML(priceCents, compareCents, fmt) {
      const price = formatMoney(priceCents, fmt);
      const compare = compareCents ? formatMoney(compareCents, fmt) : null;

      // Regular or Sale structure (keeps Dawn classes)
      if (compare && compareCents > priceCents) {
        return `
          <div class="price__container">
            <div class="price__sale">
              <span class="visually-hidden">Sale price</span>
              <span class="price-item price-item--sale price-item--last">${price}</span>
              <span class="visually-hidden">Regular price</span>
              <s class="price-item price-item--regular">${compare}</s>
            </div>
          </div>`;
      }
      return `
        <div class="price__container">
          <div class="price__regular">
            <span class="price-item price-item--regular title-font text-title-x-large text-color-primary-dark">${price}</span>
          </div>
        </div>`;
    }

    function formatMoney(cents, format) {
      cents = Math.round(Number(cents) || 0);
      if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(cents, format);               // => "$90.00 AUD"
      }
      // Fallback: simple token replacement (keeps " AUD" in format)
      var amount = (cents / 100).toFixed(2);
      return (format || '${{amount}}').replace('{{amount}}', amount);
    }



    function toNumber(v) {
      return Number(String(v || '').replace(/[^\d.-]/g, '')) || 0;
    }

    function clampQty(q, input) {
      const min = toNumber(input.getAttribute('min')) || 1;
      const max = toNumber(input.getAttribute('max')) || Infinity;
      const inc = toNumber(input.getAttribute('step')) || 1;
      q = Math.max(min, Math.min(max, q || min));
      // Ensure it respects increments
      if (inc > 1) {
        const steps = Math.round((q - min) / inc);
        q = min + steps * inc;
      }
      // Write back normalized value so UI stays in sync
      if (String(input.value) !== String(q)) input.value = q;
      return q;
    }

    // Initial sync (sets price based on initial qty)
    dispatch();
  }
})();
